export function goToDetail({ router, routeName, slug, id }) {
    router.push({
        name: routeName,
        params: {
            slug: slug,
            id: id
        }
    });
}

export function goToEdit({ router, routeName, slug, id }) {
    router.push({
        name: routeName,
        params: {
            slug: slug,
            id: id
        }
    });
}

export function deleteItem({
    api,
    slug,
    model,
    id,
    confirmMessage = "Opravdu si přejete smazat tuto položku?",
    successCallback = () => {},
    errorCallback = (error) => console.error("Error deleting item.", error),
    redirect = null,
    router = null,
}) {
    if (!window.confirm(confirmMessage)) return;

    api.delete(`/dashboard/${slug}/${model}/${id}/delete`)
    .then(() =>{
        successCallback();

        if (redirect && router) {
            router.push({
                name: redirect,
                params: {
                    slug: slug
                }
            });
        }
    })
    .catch(errorCallback);
}